import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { StorageService } from './services/storage/storage.service';
import { UsuarioRegistrarModel } from './models/seguridad/UsuarioRegistrarModel';
import { IUsuarioRegistrarModel } from './models/interfaces/seguridad/IUsuarioRegistrarModel';
import { MatSidenav } from '@angular/material/sidenav';
import { Roles, TipoUsuario } from './models/common/enumModel';
import { Router } from '@angular/router';
import { ParametroService } from './services/parametros/parametro.service';
import { OktaAuthService } from './services/OktaAuth/okta-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  user!: UsuarioRegistrarModel;
  isAuthenticated: boolean = false;
  hasRoles: boolean = false;
  idTipoUsuario: number = 0;

  usuarioEngie = TipoUsuario.Empleado;
  usuarioContratista = TipoUsuario.Contratista;

  esAdministrador: boolean = false;
  esCoordinador: boolean = false;
  esSolicitante: boolean = false;
  esRevisor: boolean = false;
  esSupervisor: boolean = false;
  esVigilante: boolean = false;
  esAdministradorSSO: boolean = false;
  esResponsableHIPO: boolean = false;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  title = 'ENGIE - Control Accesos';
  @ViewChild('drawer') sidenav!: MatSidenav;
  
  constructor(
    private breakpointObserver: BreakpointObserver,
    public storageService: StorageService,
    public oktaAuth: OktaAuthService,
    public router: Router,
    private parametros: ParametroService
    ) {
      
  }

  async ngOnInit() {
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    
    // console.log("Okta: ");
    // console.log(this.isAuthenticated);

    if(!this.isAuthenticated)
      this.isAuthenticated = this.storageService.isAuthenticated();    

    // console.log("autenticado:" + this.isAuthenticated);

    if(this.isAuthenticated){
      let usuario = this.storageService.getCurrentUser();
      this.idTipoUsuario = usuario.idTipo;
      this.esAdministrador = usuario.esAdministrador;
      if(usuario.selectedRoles){
        this.esCoordinador = usuario.selectedRoles.find(p => p === Roles.COORDINADOR_SSO)? true : false;
        this.esSolicitante = usuario.selectedRoles.find(p => p === Roles.SOLICITANTE)? true : false;
        this.esSupervisor = usuario.selectedRoles.find(p => p === Roles.SUPERVISOR)? true : false;
        this.esRevisor = usuario.selectedRoles.find(p => p === Roles.REVISOR)? true : false; 
        this.esVigilante = usuario.selectedRoles.find(p => p === Roles.VIGILANTE)? true : false;      
        this.esAdministradorSSO = usuario.selectedRoles.find(p => p === Roles.ADMINISTRADORSSO)? true : false;
        this.esResponsableHIPO = usuario.selectedRoles.find(p => p === Roles.RESPONSABLEHIPO)? true : false;
        this.hasRoles = true;
      }
      else{
        this.sidenav.close();
      }
    }
    else{
      // this.isAuthenticated = false;        
      this.sidenav.close();
    }

    this.storageService.getEmitter().subscribe((value: IUsuarioRegistrarModel) => {
      this.user = value;
      
      // console.log(this.user);

      if(this.user.isLogged){
        this.isAuthenticated = true;
        this.idTipoUsuario = value.idTipo;
        this.esAdministrador = value.esAdministrador;
        if(value.selectedRoles){
          this.esCoordinador = value.selectedRoles.find(p => p === Roles.COORDINADOR_SSO)? true : false;
          this.esSolicitante = value.selectedRoles.find(p => p === Roles.SOLICITANTE)? true : false;
          this.esSupervisor = value.selectedRoles.find(p => p === Roles.SUPERVISOR)? true : false;
          this.esRevisor = value.selectedRoles.find(p => p === Roles.REVISOR)? true : false; 
          this.esVigilante = value.selectedRoles.find(p => p === Roles.VIGILANTE)? true : false;   
          this.esAdministradorSSO = value.selectedRoles.find(p => p === Roles.ADMINISTRADORSSO)? true : false; 
          this.esResponsableHIPO = value.selectedRoles.find(p => p === Roles.RESPONSABLEHIPO)? true : false;  
          this.hasRoles = true;
        }
        else{
          this.sidenav.close();
        }
      }
      else{
        this.hasRoles = false;
        this.isAuthenticated = false;
        this.sidenav.close();
      }
      // console.log("usuario:");
      // console.log(this.user);
    });
  }
}
